/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  getFlowType,
  getSession,
  getLTEUpgrade,
  getAPPID,
  isCBandProQualifiedSession,
  enableSelfSetup,
  isVFEligibile,
  checkIsMidnight,
  isWHWPhase2Flag,
  isWHWP2,
  checkIsDisneyBundlePromo,
} from '../../../Helpers/index';
import { getProductRefData } from '../../../../../utils/plansReference';
import { getItemFromStore } from '../../../../../utils/sessionStorage';
import CommonSection, { filterProducts } from '../component/commonSection';
import { DISNEY_PROMO_ID, SPL_DISCOUNT_PROMO_IDS, VISION_FEATURE_CODE } from '../../Constants';

class Product extends Component {
  renderHTMLContentDueToday = (item, plansReferenceData, LoanTermLTE) => {
    console.log(item);
    const { planInfo, equipmentUpgradeTitle, equipmentUpgradeValue, mtnValue } = filterProducts(item, plansReferenceData, this.props.EUPDetails);
    this.planInfo = planInfo;
    const { whwPlusName, whwBasicName, extendertext } = window.vzFlags || {};
    let prodName;
    const whwProdName =
      isWHWP2() && item && item.itemType && item.itemType.includes('WHWPLUS')
        ? whwPlusName || 'Whole-Home Wi-Fi Plus'
        : whwBasicName || 'Whole-Home Wi-Fi';
    if (!isWHWP2()) {
      prodName = item && item.name;
    } else if (isWHWP2() && item && item.itemType && item.itemType.includes('WHW')) {
      prodName = whwProdName;
    } else if (this.planInfo && this.planInfo.length > 0) {
      if (this.flowType === 'LTE') {
        prodName = this.planInfo[0].minicart_Tdy_lte;
      } else if (isCBandProQualifiedSession()) {
        prodName = this.getProdNameorCBandProQualifiedSession('daily');
      } else {
        prodName = this.planInfo[0].minicart_Tdy_5g;
      }
    }
    const planID = prodName?.replace(/\s/g, '');
    const isTgwFlow = getSession('isTGW');
    const isWHWExtender = isWHWP2() && item?.itemType?.includes('WHW');
    return (
      <>
        {prodName && (
          <CommonSection
            leftValueText={prodName}
            rightValueText={
              <>
                {(this.flowType === 'LTE' &&
                  item.itemType === 'DEVICE' &&
                  !item.isHomePhone &&
                  item.totalAmountWithDiscount &&
                  item.totalAmountWithDiscount === '0.0' &&
                  item.discountApplied &&
                  item.discountApplied !== '0.0') ||
                (!isWHWP2() && item?.itemType === 'WHWBASIC' && item?.totalAmountWithDiscount === '0.00') ||
                isWHWExtender ||
                (!isWHWP2() && item?.itemType === 'ACCESSORY' && item?.bundleProductId && isTgwFlow) ? (
                  'Included'
                ) : item?.discountApplied && item.discountApplied !== '0.0' && item.totalAmountWithDiscount && item.actualAmount ? (
                  item.fullPriceDiscount && item.totalAmountWithDiscount ? (
                    `${item.totalAmountWithDiscount !== '0.0' && item.totalAmountWithDiscount !== undefined ? `$${parseFloat(item?.totalAmountWithDiscount).toFixed(2)}` : 'Included'}`
                  ) : (
                    <>
                      <div>{`$${parseFloat(item.totalAmountWithDiscount).toFixed(2)}`}</div>
                      <div className="textDecoration">{`$${parseFloat(item.actualAmount).toFixed(2)}`}</div>
                    </>
                  )
                ) : (
                  !isWHWP2() &&
                  item.discountApplied &&
                  item.discountApplied === '0.0' &&
                  item.totalAmountWithDiscount &&
                  `${item.totalAmountWithDiscount !== '0.0' ? `$${parseFloat(item.totalAmountWithDiscount).toFixed(2)}` : 'Included'}`
                )}
              </>
            }
            id={planID}
            className="normalStyle"
            subTitle={
              <>
                {getLTEUpgrade() && equipmentUpgradeTitle !== '' ? (
                  <div>
                    <div>{equipmentUpgradeTitle}</div>
                    <div>
                      {equipmentUpgradeValue}
                      <span className="MTNValue">{mtnValue}</span>
                    </div>
                  </div>
                ) : (
                  ''
                )}
                <div>{isWHWP2() && item?.itemType.includes('WHW') && (extendertext || 'Wi-Fi Extender')}</div>

                {item &&
                  isWHWP2() &&
                  LoanTermLTE !== '0' &&
                  item?.itemType.includes('WHW') &&
                  !item?.bundleProductId &&
                  !item?.giftCard &&
                  `Quantity: ${item?.quantity}`}
                {item &&
                  !isWHWP2() &&
                  LoanTermLTE !== '0' &&
                  item.itemType === 'ACCESSORY' &&
                  !item.bundleProductId &&
                  !item.giftCard &&
                  `Quantity: ${item?.quantity}`}
                {!isWHWP2() && item && item?.itemType === 'WHWBASIC' && `After redemption`}
              </>
            }
          />
        )}
      </>
    );
  };

  getProdNameorCBandProQualifiedSession = (frequency) => {
    if (frequency === 'monthly')
      return this.planInfo?.[0]?.minicart_Mly_5g_CBandPro ? this.planInfo?.[0]?.minicart_Mly_5g_CBandPro : this.planInfo?.[0]?.minicart_Mly_5g;
    return this.planInfo?.[0]?.minicart_Tdy_5g_CBandPro ? this.planInfo?.[0]?.minicart_Tdy_5g_CBandPro : this.planInfo?.[0]?.minicart_Tdy_5g;
  };

  renderHTMLContentDueMonthly = (item, plansReferenceData, flowType, downPayAmount) => {
    this.planInfo = getProductRefData(item.sorId, item.productId, plansReferenceData);
    if (item?.name?.startsWith('Auto') && item.itemType === 'DISCOUNT' && flowType === 'LTE') {
      this.planInfo = getProductRefData('LTEAUTOPAY', '', plansReferenceData);
    } else if (item?.name?.includes('Loyalty') && item.itemType === 'DISCOUNT' && flowType === 'LTE') {
      this.planInfo = getProductRefData('LTELOYALTY', '', plansReferenceData);
    }
    if (item && item.isHomePhone && item.itemType === 'PLAN') {
      const phoneNumber = getItemFromStore('home_line');
      const value = phoneNumber && phoneNumber !== '' && `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}`;
      this.npaNXXValue = value && value !== '' && value.concat('-XXXX');
      if (item.npaNXX) {
        const phoneNumberFromAPI = item.npaNXX;
        const spilittedValue = phoneNumberFromAPI && `${phoneNumberFromAPI.slice(0, 3)}-${phoneNumberFromAPI.slice(3, 6)}`;
        this.npaNXXValueFromAPI = spilittedValue && spilittedValue.concat('-XXXX');
      } else {
        this.npaNXXValueFromAPI = '';
      }
    }
    const { whwPlusName, whwBasicName } = window.vzFlags || {};
    let prodName;
    const whwProdName =
      isWHWP2() && item && item.itemType && item.itemType.includes('WHWPLUS')
        ? whwPlusName || 'Whole-Home Wi-Fi Plus'
        : whwBasicName || 'Whole-Home Wi-Fi';
    if (item.name && item.itemType !== 'SUBSCRIPTION') {
      prodName = isWHWP2() && item && item.itemType && item.itemType.includes('WHW') ? whwProdName : item.name;
    } else if (this.planInfo && this.planInfo.length > 0) {
      if (this.flowType === 'LTE') {
        prodName = this.planInfo[0].minicart_Mly_lte;
      } else if (isCBandProQualifiedSession()) {
        prodName = this.getProdNameorCBandProQualifiedSession('monthly');
      } else {
        prodName = this.planInfo[0].minicart_Mly_5g;
      }
    }
    const isDiscountIncluded = item?.itemType?.toLowerCase()?.includes('discount');
    const isMidnight = checkIsMidnight();
    const promoApplied = item?.discountsAndPromotions?.promos || [];

    const specialDiscountPromos = promoApplied?.filter((appliedDiscount) => SPL_DISCOUNT_PROMO_IDS.includes(appliedDiscount?.id));
    const isHavingSpecialDiscount = specialDiscountPromos?.length > 0;
    let finalPrice = 0;
    if (isHavingSpecialDiscount) {
      finalPrice = parseFloat(item?.discountsAndPromotions?.actualPrice) - parseFloat(specialDiscountPromos[0]?.amountOff);
    }

    return (
      <>
        {getAPPID() === 'AAL' && enableSelfSetup() ? (
          item &&
          ((item.itemType === 'PLAN' && !item.isHomePhone) ||
            item.itemType === 'DISCOUNT' ||
            (isMidnight && item.itemType === 'PERK') ||
            (isWHWPhase2Flag() && item.itemType === 'WHWPLUS')) &&
          (item.itemType !== 'PROTECTION' || item.itemType !== 'SUBSCRIPTION') && (
            <>
              <CommonSection
                leftValueText={prodName}
                rightValueText={
                  item.totalAmountWithDiscount && (
                    <>
                      {item.isAccountDiscount && isDiscountIncluded ? (
                        `-$${parseFloat(item.totalAmountWithDiscount).toFixed(2)}`
                      ) : isMidnight && item.itemType === 'PERK' ? (
                        <>
                          {parseFloat(item?.actualAmount)?.toFixed(2) !== parseFloat(item?.totalAmountWithDiscount)?.toFixed(2) && (
                            <span className="actualPriceStrikeThrough">${parseFloat(item?.actualAmount)?.toFixed(2)}</span>
                          )}
                          <span>
                            &nbsp;$
                            {item?.productId === VISION_FEATURE_CODE && item?.discountsAndPromotions
                              ? isHavingSpecialDiscount
                                ? parseFloat(finalPrice)?.toFixed(2)
                                : parseFloat(item?.discountsAndPromotions?.actualPrice)?.toFixed(2)
                              : parseFloat(item?.totalAmountWithDiscount)?.toFixed(2)}
                          </span>
                        </>
                      ) : item.itemType === 'DISCOUNT' &&
                        item.name &&
                        (item?.name?.startsWith('Auto') ||
                          item?.name?.includes('Loyalty') ||
                          item?.name?.includes('Employee') ||
                          item?.name?.includes('Mobile + Home Discount') ||
                          item?.isCouponDiscount ||
                          item?.name?.includes('Unlimited')) &&
                        item.totalAmountWithDiscount ? (
                        'Included'
                      ) : item.itemType === 'DEVICE' && Math.sign(item.totalAmountWithDiscount) === -1 && downPayAmount.downPaymentAmount > 0 ? (
                        `${item.totalAmountWithDiscount === '0.0' ? 'Included' : `$${Math.abs(parseFloat(item.totalAmountWithDiscount).toFixed(2))}`}
                                Credit`
                      ) : (flowType !== 'LTE' && item.totalAmountWithDiscount === '0.0') ||
                        (isWHWP2() && item?.itemType.includes('WHW')) ||
                        (item?.isAccountDiscount === false && isDiscountIncluded) ? (
                        'Included'
                      ) : (
                        `$${parseFloat(item.totalAmountWithDiscount).toFixed(2)}`
                      )}
                    </>
                  )
                }
                id="Product Info"
                className="normalStyle"
                subTitle={
                  item.itemType &&
                  item.itemType === 'DEVICE' &&
                  flowType === 'LTE' &&
                  !item.isHomePhone && (
                    <>
                      {this.planInfo && this.planInfo.length > 0 && this.planInfo[0].dueMonthlyText
                        ? this.planInfo[0].dueMonthlyText
                        : '24 Monthly Payments'}
                      {downPayAmount && downPayAmount.downPaymentAmount > 0 && <p>{`with $${item.sbdOfferAmount}/mo credit applied`}</p>}
                    </>
                  )
                }
              />
              {checkIsDisneyBundlePromo() &&
                promoApplied.map((promo) => {
                  const isDisneyPromo = promo.id === DISNEY_PROMO_ID;
                  return (
                    <>
                      {isDisneyPromo ? (
                        <CommonSection
                          leftValueText={promo?.description}
                          rightValueText={`-$${parseFloat(promo?.amountOff).toFixed(2)}`}
                          id="Promo-Offer"
                          subTitle={this.props.disneyPromoHelperText}
                          promoDiscount
                        />
                      ) : null}
                    </>
                  );
                })}
            </>
          )
        ) : (
          <>
            <CommonSection
              leftValueText={prodName}
              rightValueText={
                item.totalAmountWithDiscount && (
                  <>
                    {/* {isWHWP2() && item?.itemType.includes('WHW') && parseFloat(item?.totalAmountWithDiscount).toFixed(2) === '0.00'
                    ? 'Included'
                    : `$${parseFloat(item?.totalAmountWithDiscount).toFixed(2)}`} */}

                    {item.isAccountDiscount && isDiscountIncluded ? (
                      `-$${parseFloat(item.totalAmountWithDiscount).toFixed(2)}`
                    ) : isMidnight && item?.itemType === 'PERK' ? (
                      <>
                        {parseFloat(item?.actualAmount)?.toFixed(2) !== parseFloat(item?.totalAmountWithDiscount)?.toFixed(2) && (
                          <span className="actualPriceStrikeThrough">${parseFloat(item?.actualAmount)?.toFixed(2)}</span>
                        )}
                        <span>
                          &nbsp;$
                          {item?.productId === VISION_FEATURE_CODE && item?.discountsAndPromotions
                            ? isHavingSpecialDiscount
                              ? parseFloat(finalPrice)?.toFixed(2)
                              : parseFloat(item?.discountsAndPromotions?.actualPrice)?.toFixed(2)
                            : parseFloat(item?.totalAmountWithDiscount)?.toFixed(2)}
                        </span>
                      </>
                    ) : item.itemType === 'DISCOUNT' &&
                      item.name &&
                      (item?.name?.startsWith('Auto') ||
                        item?.isCouponDiscount ||
                        item?.name?.includes('Loyalty') ||
                        item?.name?.includes('Mobile + Home Discount') ||
                        item?.name?.includes('Employee') ||
                        item?.name?.includes('Unlimited')) &&
                      item.totalAmountWithDiscount ? (
                      'Included'
                    ) : item.itemType === 'DEVICE' && Math.sign(item.totalAmountWithDiscount) === -1 && downPayAmount.downPaymentAmount > 0 ? (
                      `${item.totalAmountWithDiscount === '0.0' ? 'Included' : `$${Math.abs(parseFloat(item.totalAmountWithDiscount).toFixed(2))}`}
                          Credit`
                    ) : (!isWHWP2() && flowType !== 'LTE' && item?.totalAmountWithDiscount === '0.0') ||
                      (item?.isAccountDiscount === false && isDiscountIncluded) ||
                      (isWHWP2() && item?.itemType.includes('WHW') && item?.totalAmountWithDiscount === '0.0') ? (
                      'Included'
                    ) : (
                      `$${parseFloat(item?.totalAmountWithDiscount).toFixed(2)}`
                    )}
                  </>
                )
              }
              id="Product Info"
              className="normalStyle"
              subTitle={
                <>
                  {item.isHomePhone && (item.npaNXX ? this.npaNXXValueFromAPI : this.npaNXXValue && this.npaNXXValue)}
                  {item.itemType && item.itemType === 'DEVICE' && flowType === 'LTE' && !item.isHomePhone && (
                    <div>
                      {this.planInfo && this.planInfo.length > 0 && this.planInfo[0].dueMonthlyText
                        ? this.planInfo[0].dueMonthlyText
                        : '24 Monthly Payments'}
                      {downPayAmount && downPayAmount.downPaymentAmount > 0 && <p>{`with $${item.sbdOfferAmount}/mo credit applied`}</p>}
                    </div>
                  )}
                  <div> {isWHWP2() && 'Plus taxes and surcharges. Billed after shipment.'}</div>
                  <div>{(isWHWP2() && item?.itemType.includes('WHW') && 'Wi-Fi Extender') || ''}</div>
                  {item && isWHWP2() && item?.itemType.includes('WHW') && !item.bundleProductId && !item.giftCard && `Quantity: ${item?.quantity}`}

                  {/* since  the ui doesnt have after setup for homephone , commented this condition
                  {item.itemType && item.itemType === 'PLAN' && item.isHomePhone && (
                    this.planInfo && this.planInfo.length > 0 && this.planInfo[0].activateText ? this.planInfo[0].activateText : 'After setup*'
                  )} */}
                  {item.itemType &&
                    (item.itemType === 'PROTECTION' || item.itemType === 'SUBSCRIPTION') &&
                    (item.itemType === 'PROTECTION'
                      ? this.planInfo && this.planInfo.length > 0 && this.planInfo[0].activateText
                        ? `${this.planInfo[0].activateText} ${this.props.taxFeeText || ''}`
                        : `After Activation ${this.props.taxFeeText || ''}`
                      : this.planInfo && this.planInfo.length > 0 && this.planInfo[0].activateText
                        ? `${this.planInfo[0].activateText}`
                        : 'After Activation')}
                </>
              }
            />
            {checkIsDisneyBundlePromo() &&
              promoApplied.map((promo) => {
                const isDisneyPromo = promo.id === DISNEY_PROMO_ID;
                return (
                  <>
                    {isDisneyPromo ? (
                      <CommonSection
                        leftValueText={promo?.description}
                        rightValueText={`-$${parseFloat(promo?.amountOff).toFixed(2)}`}
                        id="Promo-Offer"
                        subTitle={this.props.disneyPromoHelperText}
                        promoDiscount
                      />
                    ) : null}
                  </>
                );
              })}
          </>
        )}
      </>
    );
  };

  render() {
    const { dueTodayList = [], dueMonthlyList = [], plansReferenceData, showDueToday, showDueMonthly, downPaymentAmount } = this.props;
    const downPayAmount = downPaymentAmount;
    const LoanTermLTE = getSession('LoanTermLTE');
    this.flowType = getFlowType();

    return (
      <React.Fragment>
        {showDueToday &&
          dueTodayList?.length &&
          dueTodayList.map((item) => this.renderHTMLContentDueToday(item, plansReferenceData, LoanTermLTE, this.flowType))}
        {showDueMonthly &&
          dueMonthlyList?.length > 0 &&
          dueMonthlyList?.map((item) =>
            isVFEligibile()
              ? item?.name?.indexOf('Verizon Forward') === -1 &&
                this.renderHTMLContentDueMonthly(item, plansReferenceData, this.flowType, downPayAmount)
              : this.renderHTMLContentDueMonthly(item, plansReferenceData, this.flowType, downPayAmount),
          )}
      </React.Fragment>
    );
  }
}
Product.propTypes = {
  dueTodayList: PropTypes.array,
  dueMonthlyList: PropTypes.array,
  showDueToday: PropTypes.bool,
  showDueMonthly: PropTypes.bool,
  plansReferenceData: PropTypes.object,
  EUPDetails: PropTypes.object,
  downPaymentAmount: PropTypes.any,
  taxFeeText: PropTypes.string,
  disneyPromoHelperText: PropTypes.string,
};

export default Product;
